import { Button } from '@/components/generic';

type NoFoundProps = {
  title: string;
  sub?: string;
  options?: string[];
};

export const NoFound = ({ title, sub, options }: NoFoundProps) => (
  <div className='pt-10 pb-8 text-center max-md:py-16'>
    <div className='inline-block mb-2 text-h4'>{title}</div>
    {sub && <div className='text-sub-title-1 text-t-tertiary'>{sub}</div>}
    {
      <div className='flex flex-wrap justify-center gap-3 max-w-107 mt-8 mx-auto'>
        {options?.map((item) => (
          <Button
            className='gap-2 !h-11 !px-3.5 !text-body-2 !font-normal'
            icon='search'
            key={item}
            isStroke
          >
            {item}
          </Button>
        ))}
      </div>
    }
  </div>
);
